// 1. React and fabric. 
import * as React from 'react';
// 2. Store and Types. 
import IDashletProps                       from '../types/IDashletProps'        ;
// 3. Scripts. 
// 4. Components and Views. 
import BaseMyFavoriteDashlet               from './BaseMyFavoriteDashlet'       ;

const MODULE_NAME   : string = 'Quotes';
const SORT_FIELD    : string = 'DATE_QUOTE_EXPECTED_CLOSED';
const SORT_DIRECTION: string = 'desc';

export default class MyFavoriteQuotes extends React.Component<IDashletProps>
{
	public render()
	{
		//console.log((new Date()).toISOString() + ' ' + this.constructor.name + '.render', SETTINGS_EDITVIEW, DEFAULT_SETTINGS);
		return (
			<BaseMyFavoriteDashlet
				{ ...this.props }
				MODULE_NAME={ MODULE_NAME }
				SORT_FIELD={ SORT_FIELD }
				SORT_DIRECTION={ SORT_DIRECTION }
			/>
		)
	}
}
